var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserprofile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1434_7746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.468184 18.0003C0.0904389 17.8547 -0.0054068 17.6058 0.000231185 17.277C0.073525 14.0452 3.03347 11.1752 6.85038 10.6538C7.32397 10.588 7.81447 10.5598 8.29934 10.5504C9.15631 10.5363 10.0133 10.527 10.8703 10.5504C14.1234 10.6491 16.5026 11.9361 18.0643 14.2942C18.6789 15.2195 18.9438 16.2342 19.0002 17.291C19.0171 17.6199 18.8987 17.8594 18.5323 18.0003C12.5109 18.0003 6.48955 18.0003 0.468184 18.0003Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49515 9.49322C6.3548 9.49322 3.79515 7.35125 3.80079 4.73486C3.81207 2.12317 6.36607 0 9.50079 0C12.6468 0 15.2008 2.13727 15.1952 4.75835C15.1895 7.37004 12.6299 9.49322 9.49515 9.49322Z",
    fill: "#5B5B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1434_7746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserprofile);
export default __webpack_public_path__ + "static/media/userprofile.fd3b911cc23c6c5ef4d26e4d65320536.svg";
export { ForwardRef as ReactComponent };